import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { Layout, LayoutType } from '@features/workspace/components/layouts';
import UserEdit from '@features/workspace/components/users/edit';
import UserCreate from '@features/workspace/components/users/create';
import UserArchive from '@features/workspace/components/users/archive';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { setActiveBankAccountNumber } from '@features/workspace/store';
import { selectActiveBankAccountNumber } from '@features/workspace/store/selectors';
import { useEffect } from 'react';
import BankingAccountTransactions from '@features/workspace/views/banking/account/transactions';
import BankingAccountStatements from '@features/workspace/views/banking/account/statements';
import BankingLayout from '@/components/layout/BankingLayout';

const BankingAccountRouter = () => {
  const { account_id } = useParams();
  const activeBankAccountNumber = useAppSelector(selectActiveBankAccountNumber);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (account_id !== activeBankAccountNumber) {
      dispatch(setActiveBankAccountNumber(account_id));
    }
  }, [account_id, activeBankAccountNumber, dispatch]);

  return (
    <Routes>
      <Route
        element={
          <Layout hasHeader={false} layoutType={LayoutType.BANKING}>
            <UserCreate backUri={`/customer/banking/${account_id}/manage`} />
          </Layout>
        }
        path="/manage/users/create"
      />
      <Route
        element={
          <Layout hasHeader={false} layoutType={LayoutType.BANKING}>
            <UserArchive backUri={`/customer/banking/${account_id}/manage`} />
          </Layout>
        }
        path="/manage/users/archive"
      />
      <Route
        element={
          <Layout hasHeader={false} layoutType={LayoutType.BANKING}>
            <UserEdit backUri={`/customer/banking/${account_id}/manage`} />
          </Layout>
        }
        path="/manage/users/:user_id/edit"
      />
      <Route
        element={
          <BankingLayout>
            <BankingAccountTransactions />
          </BankingLayout>
        }
        path="/transactions"
      />
      <Route
        element={
          <BankingLayout>
            <BankingAccountStatements />
          </BankingLayout>
        }
        path="/statements"
      />
      <Route
        element={
          <Navigate
            replace
            to={`/customer/banking/${account_id}/transactions`}
          />
        }
        path="/"
      />
    </Routes>
  );
};

export default BankingAccountRouter;
